import * as React from 'react'

import { observable } from 'mobx'

import type { IncidenceQueryData } from 'modules/bookkeepers/hooks/useGetIncidences'

type CurrentIncidenceContextValue = IncidenceQueryData | null

const CurrentIncidenceContext = React.createContext<CurrentIncidenceContextValue>(null)

interface CurrentIncidenceProviderProps {
  incidence: IncidenceQueryData
}

export const CurrentIncidenceProvider = ({
  incidence,
  children,
}: React.PropsWithChildren<CurrentIncidenceProviderProps>) => (
  <CurrentIncidenceContext.Provider value={incidence}>{children}</CurrentIncidenceContext.Provider>
)

export const useCurrentIncidence = (): IncidenceQueryData => {
  const incidence = React.useContext(CurrentIncidenceContext)

  if (!incidence) {
    throw new Error('useCurrentIncidence must be used within a CurrentIncidenceProvider')
  }

  return observable(incidence)
}
